import React, { Component } from "react";
import {
  Confirm,
  Button,
  Container,
  Form,
  Icon,
  Message
} from "semantic-ui-react";
import Validator from "validatorjs";

import request from "../../utils/request";
import CheckboxFilter from "../../components/forms/elements/CheckboxFilter";

const resetState = () => {
  return {
    xhr: {
      status: "",
      message: ""
    },
    confirm: {
      open: false,
      id: 0,
      content: ""
    },
    loading: false,
    events: [],
    formdata: {
      message: "",
      eventIds: []
    }
  };
};

class SmsForm extends Component {
  constructor(props) {
    super(props);
    this.state = resetState();
    this.rules = {
      message: "required",
      eventIds: "required"
    };
    this.state.validation = new Validator(this.state.formdata, this.rules);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount = async () => {
    this.startLoading();
    const events = request.post(this, "api:/event", {
      sort: [{ id: "date", desc: true }, { id: "start_time", desc: true }],
      limit: 2000
    });
    const resp = await events;
    let eventList = [];
    resp.rows.map(value => {
      return eventList.push({
        text: value.title,
        value: parseInt(value.id)
      });
    });
    this.setState(
      {
        events: eventList
      },
      this.doneLoading
    );
  };
  componentWillUnmount = () => {
    this.setState(resetState());
  };
  startLoading = () => {
    this.setState({ loading: true });
  };
  doneLoading = () => {
    this.setState({ loading: false });
  };
  handleChange = (e, { name, value }) => {
    let formdata = { ...this.state.formdata };
    formdata[name] = value;
    this.setState({ formdata });
  };
  handleSubmit = async () => {
    let validation = new Validator(this.state.formdata, this.rules);
    this.setState({ validation });
    if (validation.passes()) {
      this.startLoading();
      await request
        .post(this, "api:/sms/pre-check", { eventIds: this.state.formdata.eventIds })
        .then(resp => {
          let content = (
            <div className="content">
              Your message will be sent to approximately{" "}
              <strong>{resp.count}</strong> subscribers
            </div>
          );
          if (resp.count === 0)
            content = (
              <div className="content">
                No customers found for the selected event(s).
              </div>
            );
          this.setState(
            {
              confirm: {
                open: true,
                id: resp.count,
                content: content
              }
            },
            this.doneLoading
          );
        });
    }
  };
  handleCancel = () => {
    this.setState({
      confirm: {
        open: false,
        id: 0,
        content: ""
      }
    });
  };
  handleConfirm = async () => {
    this.startLoading();
      await request
        .post(this, "api:/sms/save", this.state.formdata)
        .then(resp => {
          this.setState(
            {
              confirm: {
                open: false,
                id: 0,
                content: ""
              },
              xhr: {
                status: resp.status,
                message: resp.message
              }
            },
            this.doneLoading
          );
        });
  };
  render() {
    const { loading, xhr, confirm, validation, events, formdata } = this.state;
    const charCount = 130 - formdata.message.length;
    return (
      <Container text>
        <Confirm
          open={confirm.open}
          content={confirm.content}
          cancelButton={confirm.id > 0 ? "Cancel" : "Close"}
          confirmButton={confirm.id > 0 ? "Confirm" : false}
          onCancel={this.handleCancel}
          onConfirm={confirm.id > 0 ? this.handleConfirm : 0}
        />
        <Form
          id="campaignForm"
          loading={loading}
          success={xhr.status === "success"}
          error={xhr.status === "error"}
        >
          <Message success content={xhr.message} />
          <Message error content={xhr.message} />
          <Form.Field>
            <label>Event(s)</label>
            <CheckboxFilter
              name="events"
              options={events}
              value={formdata["eventIds"]}
              onChange={this.handleChange}
            />
          </Form.Field>
          <Form.TextArea
            label="Message"
            name="message"
            maxLength={130}
            value={formdata["message"] || ""}
            required
            error={validation.errors.has("message")}
            onChange={this.handleChange}
          />
          <p>{charCount} characters remaining</p>
          <Button loading={loading} fluid onClick={this.handleSubmit}>
            <Icon name="save" /> Submit
          </Button>
        </Form>
      </Container>
    );
  }
}

export default SmsForm;
